import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { ViewportService } from 'app/services/viewport.service';

@Component({
    selector: 'app-image-text-card',
    templateUrl: './image-text-card.component.html',
    styleUrls: ['./image-text-card.component.scss'],
})
export class ImageTextCardComponent implements OnInit, OnDestroy {
    private _unsubscribeAll: Subject<any> = new Subject<any>();
    public mobile: boolean = false;

    @Input() item;

    constructor(private viewport: ViewportService) {}

    ngOnInit(): void {
        this.viewport.isMobile$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((mobile) => (this.mobile = mobile));
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }
}
